"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRetryableObservable = void 0;
var react_1 = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var observable_1 = require("./observable");
/**
 * Create a memoized observable and unsubscribe automatically if component unmount and a
 * retry function
 * @returns [observableValue, error, isCompleted, retryFunction]
 */
function useRetryableObservable(observableGenerator, deps) {
    var _a = react_1.useState(), data = _a[0], setData = _a[1];
    var _b = react_1.useState(), error = _b[0], setError = _b[1];
    var submitted$ = react_1.useRef(new rxjs_1.BehaviorSubject(true)).current;
    var _c = observable_1.useObservable(function () {
        return submitted$.pipe(operators_1.tap(function () { return setData(undefined); }), operators_1.tap(function () { return setError(undefined); }), operators_1.switchMap(function () {
            return observableGenerator().pipe(operators_1.tap(function (result) { return setData(result); }), operators_1.catchError(function (err) {
                setError(err);
                return rxjs_1.never();
            }));
        }));
    }, deps), completed = _c[2];
    var retry = react_1.useCallback(function () { return submitted$.next(true); }, [submitted$]);
    return [data, error, completed, retry, undefined];
}
exports.useRetryableObservable = useRetryableObservable;
